import { UpdateWebhookRequest } from 'vopay';
import { useApi } from '#shared/providers/Api';

export default function useUpdateWebhook() {
  const api = useApi();

  async function updateWebhook(params: UpdateWebhookRequest) {
    try {
      const res = await api.updateWebhook(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return { updateWebhook };
}
